<style>
	.sub-menu{
		position: absolute;            
		min-width: 10rem;
		padding: .5rem 0;
		margin: .125rem 0 0;
		font-size: 1rem;
		color: #212529;
		text-align: left;
		list-style: none;
		background-color: #fff;
		background-clip: padding-box;
		border: 1px solid rgba(0,0,0,.15);
		border-radius: .25rem;
	}
</style>

<template>
	<b-dropdown-item @click.native="itemSelect(location)" @mouseover.native="showSubmenu(location)" @mouseout.native="hideSubmenu(location)">
		<span class="mt-2">{{location.name}} <i v-if="location.children.length != 0" class="fa fa-caret-down"></i></span>
		<div v-if="location.children.length != 0" class="sub-menu" hidden :ref="'location-submenu-'+location.id">
			<location-dropdown-item @location-selected="itemSelect" v-for="(child,id) in location.children" :key="id" :location="child"></location-dropdown-item>   
		</div>
	</b-dropdown-item>
</template>

<script>
	export default {
		props: [ 'location' ],
		name: 'location-dropdown-item',
		methods: {
			itemSelect(location){
				if(location.children.length == 0){
					this.$emit('location-selected',location);
				}
			},
			showSubmenu(location){
				if(location.children.length != 0){
					this.$refs['location-submenu-'+location.id].removeAttribute('hidden'); 
				}
			},
			hideSubmenu(location){
				if(location.children.length != 0){
					this.$refs['location-submenu-'+location.id].hidden = 'hidden'; 
				}
			},
		}
	}
</script>